
import React from 'react';
import { Button } from "@/components/ui/button";
import { 
  Scissors, 
  Undo, 
  Redo, 
  Play,
  Pause,
  Volume2,
  ZoomIn
} from "lucide-react";

const Toolbar = () => {
  return (
    <div className="bg-editor-medium border-b border-editor-light p-2 flex items-center justify-between">
      <div className="flex items-center space-x-1">
        <Button variant="ghost" size="icon" className="text-muted-foreground h-8 w-8 rounded hover:bg-editor-light hover:text-foreground">
          <Undo className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" className="text-muted-foreground h-8 w-8 rounded hover:bg-editor-light hover:text-foreground">
          <Redo className="h-4 w-4" />
        </Button>
        <div className="w-px h-5 bg-editor-light mx-1"></div>
        <Button variant="ghost" size="icon" className="text-muted-foreground h-8 w-8 rounded hover:bg-editor-light hover:text-foreground">
          <Scissors className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="flex items-center space-x-1">
        <Button variant="ghost" size="icon" className="text-muted-foreground h-8 w-8 rounded hover:bg-editor-light hover:text-foreground">
          <Play className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" className="text-muted-foreground h-8 w-8 rounded hover:bg-editor-light hover:text-foreground">
          <Pause className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" className="text-muted-foreground h-8 w-8 rounded hover:bg-editor-light hover:text-foreground">
          <Volume2 className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="flex items-center space-x-1">
        <span className="text-xs text-muted-foreground mr-1">50%</span>
        <Button variant="ghost" size="icon" className="text-muted-foreground h-8 w-8 rounded hover:bg-editor-light hover:text-foreground">
          <ZoomIn className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default Toolbar;
